import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { RequestForm } from '../components/RequestForm';
export function RequestFlowersPage() {
  return <div className="min-h-screen flex flex-col" data-id="element-1018">
      <Header data-id="element-1019" />
      <main className="flex-grow" data-id="element-1020">
        {/* Hero section */}
        <section className="bg-pink-700 text-white py-16" data-id="element-1021">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1022">
            <div className="text-center" data-id="element-1023">
              <h1 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-1024">
                Request Custom Flowers
              </h1>
              <p className="text-xl md:text-2xl text-pink-100 max-w-3xl mx-auto" data-id="element-1025">
                Can't find what you're looking for? Let us create a custom
                arrangement just for you
              </p>
            </div>
          </div>
        </section>
        {/* Image section */}
        <section className="py-12 bg-white" data-id="element-1026">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1027">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-1028">
              <div data-id="element-1029">
                <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-1030">
                  Custom Arrangements for Every Occasion
                </h2>
                <p className="text-lg text-gray-600 mb-6" data-id="element-1031">
                  At Sunton Florist, we understand that sometimes you need
                  something special that isn't in our regular collection. Our
                  expert florists can create custom arrangements for:
                </p>
                <ul className="space-y-3 text-gray-600" data-id="element-1032">
                  <li className="flex items-start" data-id="element-1033">
                    <span className="text-pink-700 font-bold mr-2" data-id="element-1034">•</span>
                    <span data-id="element-1035">Special events and celebrations</span>
                  </li>
                  <li className="flex items-start" data-id="element-1036">
                    <span className="text-pink-700 font-bold mr-2" data-id="element-1037">•</span>
                    <span data-id="element-1038">Corporate functions and office spaces</span>
                  </li>
                  <li className="flex items-start" data-id="element-1039">
                    <span className="text-pink-700 font-bold mr-2" data-id="element-1040">•</span>
                    <span data-id="element-1041">Weddings and anniversary celebrations</span>
                  </li>
                  <li className="flex items-start" data-id="element-1042">
                    <span className="text-pink-700 font-bold mr-2" data-id="element-1043">•</span>
                    <span data-id="element-1044">Unique gifts for special recipients</span>
                  </li>
                  <li className="flex items-start" data-id="element-1045">
                    <span className="text-pink-700 font-bold mr-2" data-id="element-1046">•</span>
                    <span data-id="element-1047">Seasonal or themed decorations</span>
                  </li>
                </ul>
              </div>
              <div className="rounded-lg overflow-hidden shadow-lg" data-id="element-1048">
                <img src="https://images.unsplash.com/photo-1563241527-3004b7be0ffd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80" alt="Custom flower arrangement" className="w-full h-auto" data-id="element-1049" />
              </div>
            </div>
          </div>
        </section>
        {/* Request form section */}
        <RequestForm data-id="element-1050" />
        {/* FAQ section */}
        <section className="py-12 bg-white" data-id="element-1051">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1052">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-1053">
              Frequently Asked Questions
            </h2>
            <div className="max-w-3xl mx-auto space-y-6" data-id="element-1054">
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1055">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1056">
                  How quickly can you fulfill custom requests?
                </h3>
                <p className="text-gray-600" data-id="element-1057">
                  We typically need 24-48 hours to source and prepare custom
                  arrangements. For urgent requests, please call us directly and
                  we'll do our best to accommodate your timeline.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1058">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1059">
                  Is there an additional cost for custom arrangements?
                </h3>
                <p className="text-gray-600" data-id="element-1060">
                  Custom arrangements are priced based on the flowers requested,
                  complexity, and size. After receiving your request, we'll
                  provide a detailed quote for your approval before proceeding.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1061">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1062">
                  Can you recreate an arrangement from a photo?
                </h3>
                <p className="text-gray-600" data-id="element-1063">
                  Yes! You can upload or email us a photo of an arrangement you
                  like, and our florists will create something similar based on
                  seasonal availability of flowers.
                </p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg" data-id="element-1064">
                <h3 className="text-lg font-semibold text-gray-900 mb-2" data-id="element-1065">
                  Do you offer custom subscriptions?
                </h3>
                <p className="text-gray-600" data-id="element-1066">
                  Absolutely. If you have specific preferences or needs for
                  regular deliveries, we can create a custom subscription plan
                  tailored to your requirements.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-1067" />
    </div>;
}